(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bnr-nav-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-nav-slider')) {
    class CollectionNavSlider extends HTMLElement {
      connectedCallback() {
        this.initSwiper();
      }

      initSwiper() {
        if (typeof Swiper === 'undefined') {
          setTimeout(this.initSwiper.bind(this), 50);
          return;
        }

        this.navButtons = Array.from(this.querySelectorAll('.collection-nav-slider__nav-button'));

        const swiperEl = this.querySelector('.collection-nav-slider__swiper');
        const wrapperEl = swiperEl.querySelector('.swiper-wrapper');
        const originalSlides = Array.from(wrapperEl.querySelectorAll('.collection-nav-slider__slide'));
        const originalCount = originalSlides.length;

        // 実スライド数が少ないとloopの内部計算が不安定になるため、
        // 十分な数になるまで実スライド自体を複製する
        const MIN_REAL_SLIDES = 8;
        if (originalCount > 0 && originalCount < MIN_REAL_SLIDES) {
          const repeatTimes = Math.ceil(MIN_REAL_SLIDES / originalCount);
          for (let r = 1; r < repeatTimes; r++) {
            originalSlides.forEach((slide) => {
              wrapperEl.appendChild(slide.cloneNode(true));
            });
          }
        }

        this.swiperInstance = new Swiper(swiperEl, {
          slidesPerView: 'auto',
          spaceBetween: 60,
          centeredSlides: true,
          loop: true,
        });

        this.swiperInstance.on('slideChangeTransitionEnd', () => {
          const activeSlide = this.swiperInstance.slides[this.swiperInstance.activeIndex];
          if (!activeSlide) return;
          const logicalIndex = parseInt(activeSlide.dataset.navIndex, 10);
          this.setActiveNav(logicalIndex);
        });

        // 複製後の各実スライドに、元のnavボタンと対応する論理indexを付与
        const allSlides = wrapperEl.querySelectorAll('.collection-nav-slider__slide');
        allSlides.forEach((slide, i) => {
          slide.dataset.navIndex = i % originalCount;
        });

        this.navButtons.forEach((button) => {
          button.addEventListener('click', () => {
            const logicalIndex = parseInt(button.dataset.slideIndex, 10);
            // 論理indexに対応する最初の実スライドのSwiper内部インデックスへジャンプ
            const targetSlide = Array.from(allSlides).find(
              (slide) => parseInt(slide.dataset.navIndex, 10) === logicalIndex
            );
            const realIndex = parseInt(targetSlide.dataset.swiperSlideIndex, 10);
            this.setActiveNav(logicalIndex);
            this.swiperInstance.slideToLoop(realIndex);
          });
        });
      }

      setActiveNav(activeIndex) {
        this.navButtons.forEach((button, index) => {
          if (index === activeIndex) {
            button.setAttribute('aria-current', 'true');
          } else {
            button.removeAttribute('aria-current');
          }
        });
      }

      disconnectedCallback() {
        if (this.swiperInstance) this.swiperInstance.destroy(true, true);
      }
    }

    customElements.define('collection-nav-slider', CollectionNavSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-banner-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-banner-slider')) {
    class CollectionBannerSlider extends HTMLElement {
      connectedCallback() {
        this.initSwiper();
      }

      initSwiper() {
        if (typeof Swiper === 'undefined') {
          setTimeout(this.initSwiper.bind(this), 50);
          return;
        }

        const swiperEl = this.querySelector('.collection-banner-slider__swiper');
        const listEl = swiperEl.querySelector('.swiper-wrapper');
        const originalSlides = Array.from(listEl.querySelectorAll('.collection-banner-slider__slide'));
        const originalCount = originalSlides.length;

        const MIN_REAL_SLIDES = 8;
        if (originalCount > 0 && originalCount < MIN_REAL_SLIDES) {
          const repeatTimes = Math.ceil(MIN_REAL_SLIDES / originalCount);
          for (let r = 1; r < repeatTimes; r++) {
            originalSlides.forEach((slide) => {
              listEl.appendChild(slide.cloneNode(true));
            });
          }
        }
        // Swiperのインスタンスを初期化（初期化完了時に swiper-initialized が自動付与され opacity が 1 になる）
        this.swiperInstance = new Swiper(swiperEl, {
          loop: true,
          slidesPerView: 'auto',
          spaceBetween: 60,
          centeredSlides: true,
          speed: 400,
        });
      }

      disconnectedCallback() {
        if (this.swiperInstance) this.swiperInstance.destroy();
      }
    }

    customElements.define('collection-banner-slider', CollectionBannerSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
